import { render } from "./GetParticipantsListSendWhatsApp.vue?vue&type=template&id=0bb7e9dc&scoped=true"
import script from "./GetParticipantsListSendWhatsApp.vue?vue&type=script&lang=js"
export * from "./GetParticipantsListSendWhatsApp.vue?vue&type=script&lang=js"

import "./GetParticipantsListSendWhatsApp.vue?vue&type=style&index=0&id=0bb7e9dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb7e9dc"]])

export default __exports__